/**
 * @generated SignedSource<<2dadff0a63638468bca0f97a13337e3d>>
 * @relayHash b61e4cd0ae42b5785f9faf177649490c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c58adc5c475a1514e2c3911457bbe43d5662e86bc08fa9cd6bc3bba1027c3110

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AsyncMenuWithQueryQuery } from './AsyncMenuWithQueryQuery.graphql';

const node: PreloadableConcreteRequest<AsyncMenuWithQueryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c58adc5c475a1514e2c3911457bbe43d5662e86bc08fa9cd6bc3bba1027c3110",
    "metadata": {},
    "name": "AsyncMenuWithQueryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
